import axios from '@/utils/http';

export default (notice, params) => {
  return axios
    .put(`/advertisement_notice/${notice}/edit`, params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
